import discountQueries from '@apis/queries/discountQueries';
import orderWithTotalAmount from '@providers/OrderProvider/utils/orderWithTotalAmount';
import { RootState } from '@store/store';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

function useCalculatedRequest() {
    const request = useSelector((root: RootState) => root.order);
    const { data: availableDiscounts } = useQuery({
        ...discountQueries.list(request.shopId),
        enabled: !!request.shopId,
    });
    return orderWithTotalAmount(request, availableDiscounts);
}

export default useCalculatedRequest;
